var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      attrs: { id: "claim-" + _vm.result.ClaimID, tabindex: "0" },
      on: {
        click: function($event) {
          return _vm.displayDetail(_vm.result)
        },
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.displayDetail(_vm.result)
        }
      }
    },
    [
      _c("span", { staticClass: "list-item-info claim-type" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Claim Type")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.result.ClaimType))
        ]),
        _vm._v(" "),
        _vm.result.ClaimType === ""
          ? _c("span", { staticClass: "novalue" }, [_vm._v("N/A")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "list-item-info po-number" }, [
        _c("span", { staticClass: "label" }, [_vm._v("PO #")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.result.DealerPONumber))
        ]),
        _vm._v(" "),
        _vm.result.DealerPONumber === ""
          ? _c("span", { staticClass: "novalue" }, [_vm._v("N/A")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "list-item-info lmc-inv" }, [
        _c("span", { staticClass: "label" }, [_vm._v("LMC Inv #")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.result.LMCInvoiceNumber))
        ]),
        _vm._v(" "),
        _vm.result.LMCInvoiceNumber === ""
          ? _c("span", { staticClass: "novalue" }, [_vm._v("N/A")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "list-item-info supplier" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Supplier")]),
        _vm._v(" "),
        _c("span", {
          staticClass: "value",
          domProps: { innerHTML: _vm._s(_vm.result.SupplierName) }
        }),
        _vm._v(" "),
        _vm.result.SupplierName === ""
          ? _c("span", { staticClass: "novalue" }, [_vm._v("N/A")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "list-item-info submit-date" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Date Submitted")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.formatDate(_vm.result.DateClaimSubmitted)))
        ]),
        _vm._v(" "),
        _vm.result.DateClaimSubmitted === ""
          ? _c("span", { staticClass: "novalue" }, [_vm._v("N/A")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "list-item-info processed" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Processed")]),
        _vm._v(" "),
        _vm.result.IsProcessed
          ? _c("span", { staticClass: "value" }, [_vm._v("Yes")])
          : _vm._e(),
        _vm._v(" "),
        !_vm.result.IsProcessed
          ? _c("span", { staticClass: "value unprocessed" }, [_vm._v("No")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "list-item-info processed-date" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Date Processed")]),
        _vm._v(" "),
        _vm.result.DateProcessed >= _vm.result.DateClaimSubmitted
          ? _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.formatDate(_vm.result.DateProcessed)))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.result.DateProcessed == null
          ? _c("span", { staticClass: "value hide-desktop unprocessed" }, [
              _vm._v("NOT PROCESSED")
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eaf6dc9", { render: render, staticRenderFns: staticRenderFns })
  }
}